import AppConfig from '../config/config';
/** Ignore the cache if it's older than this — guards against a bfcache
 *  restore serving a stale search result on back/forward navigation. */
const PRELOAD_MAX_AGE_MS = 30000;
function isPreloadDebug() {
    if (typeof window === 'undefined')
        return false;
    if (window.__PRELOAD_DEBUG__ === true)
        return true;
    try {
        return new URLSearchParams(window.location.search).get('preloadDebug') === '1';
    }
    catch (_a) {
        return false;
    }
}
/** Gated console logging for the preload consumer — silent unless
 *  `?preloadDebug=1` or `window.__PRELOAD_DEBUG__` is set. */
export function preloadLog(...args) {
    if (isPreloadDebug()) {
        // eslint-disable-next-line no-console
        console.log('[Preload]', ...args);
    }
}
/** Read `window.__SEARCH_PRELOAD_CACHE__` if present, for this store's
 *  provider, and fresh; `null` otherwise. */
export function readPreloadCache() {
    if (typeof window === 'undefined')
        return null;
    const cache = window.__SEARCH_PRELOAD_CACHE__;
    if (!cache)
        return null;
    if (cache.provider !== AppConfig.provider) {
        preloadLog('cache is for provider', cache.provider, '— this store runs', AppConfig.provider, '— ignoring');
        return null;
    }
    const age = Date.now() - cache.timestamp;
    if (age > PRELOAD_MAX_AGE_MS) {
        preloadLog('cache is', age, 'ms old (> ' + PRELOAD_MAX_AGE_MS + 'ms) — ignoring');
        return null;
    }
    return cache;
}
/** Drop the cache once it's been consumed (or deliberately skipped) so a
 *  later bfcache restore / re-render can't reuse it. */
export function clearPreloadCache() {
    if (typeof window !== 'undefined')
        delete window.__SEARCH_PRELOAD_CACHE__;
}
